<template>
  <main-layout>
    <manage-groups-container />
  </main-layout>
</template>

<script>

export default {

  name: 'ManageGroups',

  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
</style>
